import React from 'react';
import { SurveyContainer } from './components/survey';

function App() {
  return <SurveyContainer />;
}

export default App;
